import type { HotkeyValue } from '@/components/ui/KbdShortcuts'
import { KbdShortcuts } from '@/components/ui/KbdShortcuts'

/**
 * Tooltip body for transport buttons: description plus its keyboard shortcut.
 */
export function TransportTooltip({
  label,
  shortcut,
}: {
  label: string
  shortcut?: HotkeyValue
}) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span>{label}</span>

      {shortcut ? (
        <KbdShortcuts
          hotkey={shortcut}
          className="bg-white/15 text-neutral-300"
        />
      ) : null}
    </span>
  )
}
